import React, {useState} from "react";
import PropTypes from "prop-types";

function SortArrow(props) {
  const {
    changeAction,
    sortDirection
  } = props;

  const sortPoints = (!sortDirection || sortDirection === 'descending') ? '2,1,9,10,16,1' : '2,10,9,1,16,10';

  return (
      <svg height="10" width="17" xmlns="http://www.w3.org/2000/svg" onClick={changeAction}>
        <polygon points={sortPoints} className='sort-arrow'></polygon>
      </svg>
  );
}

SortArrow.propTypes = {
  changeAction: PropTypes.func.isRequired
};

export default SortArrow;